<template>
  <div class="step-layout">
    <h2 class="step-layout__title">
      {{ keyword }}に関して<br>
      {{ title }}
      <span v-if="optional" class="step-layout__optional-text">（任意）</span>
    </h2>

    <div class="step-layout__content">
      <slot />
    </div>

    <div
      v-if="showBackLink || $slots.skip"
      class="step-layout__back-skip-wrapper"
      :class="{ 'step-layout__back-skip-wrapper--skip-only': !showBackLink }"
    >
      <BackLink v-if="showBackLink" @click="handleBack" />
      <slot name="skip" />
    </div>

    <StepIndicator :current-step="currentStep" :total-steps="totalSteps" />

    <div v-if="$slots.footer" class="step-layout__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup lang="ts">
import StepIndicator from './StepIndicator.vue';
import BackLink from './BackLink.vue';

withDefaults(
  defineProps<{
    keyword: string;
    title: string;
    currentStep: number;
    totalSteps?: number;
    showBackLink?: boolean;
    optional?: boolean;
  }>(),
  {
    totalSteps: 4,
    showBackLink: true,
    optional: false,
  },
);

const emit = defineEmits<{
  back: [];
}>();

const handleBack = () => {
  emit('back');
};
</script>

<style lang="scss" scoped>
@import '~green/_variables.scss';

.step-layout {
  display: flex;
  flex-direction: column;
  padding: 16px;

  &__back-skip-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 10px 0;

    &--skip-only {
      justify-content: flex-end;
    }
  }

  &__title {
    font-size: 1.25rem;
    font-weight: bold;
    color: $base-font-color;
    text-align: center;
    margin: 0 0 24px;
    line-height: 1.4;
  }

  &__optional-text {
    font-weight: normal;
    color: #999;
  }

  &__content {
    flex: 1;
  }

  &__footer {
    display: flex;
    justify-content: center;
    margin-top: 24px;
  }
}
</style>
